// Surface-aware Navitra brand logo.
// - Light surfaces  -> navy wordmark  (/brand/navitra-logo.webp)
// - Dark surfaces    -> true white-on-transparent wordmark (/brand/navitra-logo-white.webp)
export const Logo = ({ className = "h-9", white = false, alt = "Navitra OS", ...rest }) => (
  <img
    src={white ? "/brand/navitra-logo-white.webp" : "/brand/navitra-logo.webp"}
    alt={alt}
    className={className}
    data-testid="navitra-logo"
    {...rest}
  />
);

// Explicit white variant for dark panels (no chip required).
export const LogoWhite = ({ className = "h-9", ...rest }) => (
  <Logo white className={className} {...rest} />
);

export const LogoMark = ({ className = "h-8 w-8" }) => (
  <span className={`inline-flex items-center justify-center rounded-lg bg-navy text-nav-text font-display font-bold ${className}`}>N</span>
);
